import CookiesConsentSFC from "./CookiesConsent.vue";
export const CookiesConsent = CookiesConsentSFC;
